export default "__VITE_ASSET__BSZAkdOS__"